import React from 'react'
import { observer } from 'mobx-react'

import Typography from '../../UniformComponents/Typography'

const PreviewSlideTitle = ({ slide }) => (
    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Typography type="tiny-b" style={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{slide.slideTitle}</Typography>
        {/* <Typography type="tiny">{}</Typography> */}
    </div>
)

export default observer(PreviewSlideTitle)
